"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const success_1 = require("../../../build-babel/auth/response/success");
const redirect_1 = require("../../../build-babel/redirect");
const token_1 = require("../../../build-babel/token");
const storage_1 = require("../../../build-babel/token/storage");
const handleResponse = (msalClient, response) => {
  if (response !== null) {
    const existingToken = (0, storage_1.getToken)();
    const {
      idToken,
      account
    } = response;
    msalClient.setActiveAccount(account);
    if (!(0, token_1.hasValidToken)(existingToken)) {
      (0, success_1.handleSuccess)(response);
    }
    (0, redirect_1.redirectNext)(idToken);
  }
};
exports.default = handleResponse;
//# sourceMappingURL=handler.js.map